export const readToken = () => {
  return sessionStorage.getItem("token") || "";
};

export const setToken = (access_token: string) => {
  sessionStorage.setItem("token", access_token);
}

export const removeToken = () => {
  sessionStorage.removeItem("token");
}

let timestamp = Date.now();

export function generateRandomString(length: number = 32) {
    function toBase36(num: number) {
        return num.toString(36).toUpperCase();
    }
    let result = '';
    while (result.length < length) {
        result += toBase36(timestamp/1000);
        timestamp += 1;
        let sqr=Math.sqrt(timestamp).toString();
        sqr=sqr.substring(sqr.length-2);
        timestamp+=Number(sqr);
        result+=sqr;
    }
    return result.slice(0, length);
}

export const initializeSessionId = (): string | null => {
  let sessionId = sessionStorage.getItem("sessionId") || null;
  if (!sessionId) {
    sessionId = generateRandomString();
    sessionStorage.setItem("sessionId", sessionId);;
  }
  return sessionId;
};

export const setSessionId = (sessionId: string) => {
  sessionStorage.setItem("sessionId", sessionId);;
};

export const readClientId = () => {
  return sessionStorage.getItem("clientId") || "";
};

export const setClientId = (access_token: string) => {
  sessionStorage.setItem("clientId", access_token);
}

export const removeClientId = () => {
  sessionStorage.removeItem("clientId");
}
export const storeProductList = (productList:string) => {
  localStorage.setItem("productList",productList);
}

export const getProductList = () => {
  return localStorage.getItem("productList") || "";
};